import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/reglements`;
function getAuthHeaders() {
  const token = localStorage.getItem("token");

  return {
    Authorization: `Bearer ${token}`,
  };
}

/// GET
// Fonction pour récupérer tous les réglements
export const getReglements = async () => {
  try {
    const response = await axios.get(`${apiUrl}/allreglements`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des réglements:", error);
  }
};

// Fonction getTotalAchats pour faire faire la somme de tous les achats et le détail par produits
export const getTotalAchats = async () => {
  try {
    const response = await axios.get(`${apiUrl}/totalachats`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des achats:", error);
  }
};

// Fonction pour récupérer les réglements d'un utilisateur
export const getReglementsByUser = async (userId) => {
  try {
    const response = await axios.get(`${apiUrl}/achats/user/${userId}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de la récupération des réglements de l'utilisateur:",
      error,
    );
  }
};

/// POST
// Fonction pour créer un réglement
export const createReglement = async (reglementData) => {
  try {
    await axios.post(`${apiUrl}/createreglement`, reglementData, {
      headers: getAuthHeaders(),
    });
  } catch (error) {
    console.error("Erreur lors de la création du réglement:", error);
  }
};

// Fonction pour créer des achats fractionnés
export const createAchatsFractionnes = async (data) => {
  try {
    await axios.post(`${apiUrl}/fractionnes`, data, {
      headers: getAuthHeaders(),
    });
  } catch (error) {
    console.error("Erreur lors de la création des achats fractionnés:", error);
    throw error;
  }
};

// Fonction pour créer un achat spécifique
export const createSpecialAchat = async (achatData) => {
  try {
    await axios.post(`${apiUrl}/special`, achatData, {
      headers: getAuthHeaders(),
    });
  } catch (error) {
    console.error("Erreur lors de la création de l'achat spécifique:", error);
  }
};

/// PUT
// Fonction pour modifier un réglement
export const updateReglement = async (id, reglementData) => {
  try {
    await axios.put(`${apiUrl}/updatereglement/${id}`, reglementData, {
      headers: getAuthHeaders(),
    });
  } catch (error) {
    console.error("Erreur lors de la modification du réglement:", error);
  }
};

// Fonction pour mettre à jour le statur d'un réglement après paiement
export const updateStatutReglements = async (ids, statut_reglement) => {
  try {
    await axios.put(
      `${apiUrl}/updatestatutreglements`,
      {
        ids, // Tableau d'IDs des règlements à mettre à jour
        statut_reglement, // Nouveau statut pour les règlements
      },
      {
        headers: getAuthHeaders(),
      },
    );
  } catch (error) {
    console.error(
      "Erreur lors de la mise à jour du statut du réglement:",
      error,
    );
  }
};

/// DELETE
// Fonction pour supprimer un réglement
export const deleteReglement = async (id) => {
  try {
    await axios.delete(`${apiUrl}/deletereglement/${id}`, {
      headers: getAuthHeaders(),
    });
  } catch (error) {
    console.error("Erreur lors de la suppression du réglement:", error);
  }
};
